/**
 * Official Venmo and Zelle marks, supplied by Tim on 2026-09-25 and drawn as
 * inline SVG so they stay sharp at icon size with no image request, in both the
 * Vite portal and the Next storefront. Traced from the supplied PNGs and checked
 * against them (overlap: Venmo 96.7%, Zelle 98.4% — sub-pixel at 16–24px).
 *
 * Brand colors are fixed on purpose: they are the second sanctioned off-palette
 * case after Stripe's Connect button (design-system.md → Brand exceptions).
 * Decorative (aria-hidden), like the Lucide icons they sit among: every place a
 * payment method is listed prints its name beside the icon, and a labelled mark
 * would make a screen reader say "Zelle Zelle" and rename the button.
 */
type MarkProps = { size?: number | string; className?: string }

export function VenmoMark({ size = 24, className }: MarkProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 400 400" aria-hidden="true" focusable="false" className={className}>
      <rect width="400" height="400" fill="#008CFF" />
      <path
        fill="#FFFFFF"
        d="M104,103 L178,97 L195,240 C220,195 238,160 233,125 C231,114 228,110 225,107 L293,94 C301,110 305,125 305,142 C305,195 262,255 220,305 H137 Z"
      />
    </svg>
  )
}

export function ZelleMark({ size = 24, className }: MarkProps) {
  return (
    <svg width={size} height={size} viewBox="-276 0 1353 1353" aria-hidden="true" focusable="false" className={className}>
      <path
        fill="#6D1ED4"
        d="M303,0 H488 V185 H778 V330 L279,978 H683 C720,1060 760,1100 800,1135 L785,1164 H489 V1353 H304 V1164 H0 V1016 L497,373 H20 V188 H303 Z"
      />
    </svg>
  )
}
